import PageLayout from '../../components/feature/PageLayout';
import PageHero from '../../components/feature/PageHero';
import SEO from '../../components/feature/SEO';
import Historia from './components/Historia';
import Equipo from './components/Equipo';
import Valores from './components/Valores';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

const nosotrosJsonLd = [
  {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: 'Sobre Nosotros – Taller Mecánico Kevin Alberto Ronda',
    url: `${siteUrl}/nosotros`,
    description:
      'Conoce al equipo y la historia de Taller Mecánico Kevin Alberto, taller de referencia en Ronda, Málaga desde hace más de 25 años.',
    inLanguage: 'es',
    isPartOf: { '@type': 'WebSite', url: siteUrl },
    mainEntity: {
      '@type': 'AutoRepair',
      name: 'Taller Mecánico Kevin Alberto',
      foundingDate: '2000',
      description:
        'Taller mecánico familiar en Ronda con más de 25 años de experiencia. Especialistas en mecánica general, diagnosis electrónica, chapa y pintura.',
      address: {
        '@type': 'PostalAddress',
        streetAddress: 'C. Guadalimar, 7',
        addressLocality: 'Ronda',
        postalCode: '29400',
        addressRegion: 'Málaga',
        addressCountry: 'ES',
      },
      telephone: '+34666365922',
      url: siteUrl,
    },
  },
];

const NosotrosPage = () => (
  <PageLayout>
    <SEO
      title="Quiénes Somos | Taller Mecánico Kevin Alberto Ronda Málaga – 25 Años de Experiencia"
      description="Conoce la historia y el equipo del Taller Mecánico Kevin Alberto en Ronda, Málaga. Más de 25 años de experiencia en mecánica, diagnosis y chapa. Tu taller de confianza."
      keywords="taller mecánico Ronda historia, equipo mecánicos Ronda Málaga, Kevin Alberto mecánico Ronda"
      canonical="/nosotros"
      jsonLd={nosotrosJsonLd}
    />
    <PageHero
      tag="Quiénes somos"
      title="Sobre"
      titleAccent="Nosotros"
      subtitle="Conoce al equipo y la historia detrás de Taller Mecánico Kevin Alberto en Ronda."
      breadcrumb="Nosotros"
      bgImage="https://public.readdy.ai/ai/img_res/8ec4e3d3f1ed5803996d03eb8b1c7535.jpg"
    />
    <Historia />
    <Equipo />
    <Valores />
  </PageLayout>
);

export default NosotrosPage;
